/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersistentNotificationUpdate
 */
export interface PersistentNotificationUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof PersistentNotificationUpdate
     */
    read?: boolean | null;
}

/**
 * Check if a given object implements the PersistentNotificationUpdate interface.
 */
export function instanceOfPersistentNotificationUpdate(value: object): value is PersistentNotificationUpdate {
    return true;
}

export function PersistentNotificationUpdateFromJSON(json: any): PersistentNotificationUpdate {
    return PersistentNotificationUpdateFromJSONTyped(json, false);
}

export function PersistentNotificationUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersistentNotificationUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'read': json['read'] == null ? undefined : json['read'],
    };
}

export function PersistentNotificationUpdateToJSON(json: any): PersistentNotificationUpdate {
    return PersistentNotificationUpdateToJSONTyped(json, false);
}

export function PersistentNotificationUpdateToJSONTyped(value?: PersistentNotificationUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'read': value['read'],
    };
}

